import { jsx as _jsx } from "react/jsx-runtime";
import { MenuItem } from "@mui/material";
import { forwardRef } from "react";
export const UiMenuItem = forwardRef((props, ref) => (_jsx(MenuItem, Object.assign({ ref: ref }, props))));
//# sourceMappingURL=menu_item.js.map